module.exports = __webpack_public_path__ + "static/img/13.17fb814.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/13.jpg
// module id = Vtlg
// module chunks = 1